import React from 'react'

export const BuildingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <title>Leilighetsbygg</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M3 23V1h18v22"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M9 23v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4M1 23h22M7 5h3M7 9h10m-3 4h3M7 13h3m4-8h3"
    />
  </svg>
)
